import { regex } from 'react-admin'

export const validateHourMinute = regex(/^[0-9]{2}:[0-9]{2}$/, 'Time MUST have format like "09:15"')
